module.exports = __webpack_public_path__ + "static/media/53_trends_shortcut.fc0654d7.png";